import { render, staticRenderFns } from "./GPathCareerInterList.vue?vue&type=template&id=a122b2c6"
import script from "./GPathCareerInterList.vue?vue&type=script&lang=js"
export * from "./GPathCareerInterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports